import user from "./user";
import order from "./order";
import activity from "./activity";
import answer from "./answer";

export default [...user, ...order, ...activity,...answer];
